<app-top-bar [isBack]="true" [title]="planningStatus === 'reopen' ? 'Перевідкрити звернення' : 'Завершити звернення'"></app-top-bar>
<div class="support-reason-container">
  <div class="departments-block">
    <div class="department-title block-background">{{
        planningStatus === 'reopen' ? 'Вкажіть причину перевідкриття' : 'Вкажіть причину завершення'
      }}</div>
    @for (item of reasons$ | async; track $index) {
      <div class="department-item block-background" (click)="openComment(item.id)">
        <div class="department-item-text main-text-color">{{ item.display_name }}</div>
        <mat-icon class="accent-color">chevron_right</mat-icon>
      </div>
    }
  </div>
</div>
